'use client';

import React from "react";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { BaseFormattedTime } from "./BaseFormattedTime.mjs";
import { useIntl } from "./IntlContext.mjs";
export function FormattedTime(props) {
  var {
    timezone,
    locale
  } = useIntl();
  return /*#__PURE__*/React.createElement(BaseFormattedTime, _extends({
    timezone: timezone,
    locale: locale
  }, props));
}